import { IJsonapiModel, Response } from 'datx-jsonapi';
import { useMemo } from 'react';

import { IResponse } from '@/interfaces/json-api';

import { useStores } from './useStores';

/**
 * @deprecated use store.fetchResources in gSSP in combination with <Hydrate fallback={fallback} />
 */
export function useServerSideResponse<T extends IJsonapiModel>(
  data?: IResponse | Array<IResponse>
): Response<T> | Array<Response<T>> {
  const { store } = useStores();
  const response = useMemo(() => {
    if (store && data) {
      if (Array.isArray(data)) {
        return data.map((rowResponse) => new Response<T>({ data: rowResponse, status: 200 }, store));
      }
      return new Response<T>({ data, status: 200 }, store);
    }
  }, [data, store]);

  return response;
}
